import { Desktop, Mobile } from '../../../../utils/responsive';
import React, { PureComponent } from 'react';

import PropTypes from 'prop-types';

class VerticalGutter extends PureComponent {
  render() {
    const { amount, mobile } = this.props;
    if (mobile) {
      return (
        <>
          <div style={{ height: amount }} />
        </>
      );
    }
    return <div style={{ height: amount }} />;
  }
}

VerticalGutter.propTypes = {
  amount: PropTypes.number.isRequired,
  mobile: PropTypes.number,
};

export default VerticalGutter;
